import { IOnboardNavStep } from '../nav/Interfaces';
import { OnboardNavSlugType } from '../nav/Types';
import { IOnboardStaticHierarchyResponse } from '../zeos-api/contracts/Onboarding';
import { OnboardStepEnum } from '../zeos-api/enums/Onboarding';

export const UNAUTH_STEPS: readonly OnboardNavSlugType[] = [
  "account-setup",
  "account-verification",
  "account-password",
] as const;

export const isUnauthStep = (pageSlug: string): boolean => {
  return UNAUTH_STEPS.includes(pageSlug as OnboardNavSlugType);
};

/**
 * Helper functions for onboarding navigation
 */
export class OnboardHelpers {
  /**
   * Transform static hierarchy data to IOnboardNavStep format for NavigationService
   */
  static transformStaticHierarchyToNavSteps(
    staticHierarchyData: IOnboardStaticHierarchyResponse
  ): IOnboardNavStep[] {
    if (!staticHierarchyData?.steps) {
      console.warn(
        "No steps found in static hierarchy data:",
        staticHierarchyData
      );
      return [];
    }

    try {
      return [...staticHierarchyData.steps]
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((step) => ({
          stepName: step.displayValue,
          stepNum: step.onboardStepId as OnboardStepEnum,
          subSteps: [...step.subSteps]
            .sort((a, b) => a.substepNumber - b.substepNumber)
            .map((substep) => ({
              pageSlug: substep.pageSlug as OnboardNavSlugType,
              subStepName: substep.substepName,
              subStepNum: substep.substepNumber,
              showBackButton: substep.isBackButtonVisible,
            })),
        }));
    } catch (error) {
      console.error("Error in transformStaticHierarchyToNavSteps:", error);
      console.error("Data that caused error:", staticHierarchyData);
      return [];
    }
  }
}
